module.exports = __webpack_public_path__ + "media/images/icons/filled/taobao-circle-2432306c497367f3fc6a8ea2296a6036.svg";